import React from 'react'

export class Loader extends React.Component<{}, {}> {
  render() {
    return (
      <div className="main">
        <div className="loader">
          <div className="loader__inner"></div>
        </div>
      </div>
    )
  }
}
